import * as Yup from 'yup'

export const setupValidationSchema = () => {
  return (
    Yup.object().shape({
      existing_cover: Yup.number('This should be a number')
        .typeError('This should be a number')
        .required('A value for existing cover is required')
        .min(0, `You can't have a negative existing cover value`),
      lifestyle_adjustment_expenses: Yup.number('This should be a number')
        .typeError('This should be a number')
        .required('A value for lifestyle adjustment is required')
        .min(0, `You can't have a negative lifestyle adjustment value`),
    })
  )
}
